module.exports = __webpack_public_path__ + "assets/addtext.72e7c345.svg";